import { UpsertDeviceTypeModal } from '../UpsertDeviceType/UpsertDeviceTypeModal'
import { createCreateButton } from '../../../../components/CreateButton'
import translations from '../Actions.i18n.json'

export const DeviceTypeCreateButton = createCreateButton({
  UpsertModal: UpsertDeviceTypeModal,
  translations,
})
